import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import Image_Show_Modal from "../../../../../../../common/common_modal/image_show_modal/image_show_modal";
import { formatDate } from "../../../../../../../utils/common";

const Table = ({ setEdit, managementdetails, setCurrentPage, currentPage }) => {
  const getStatusClass = (status) => {
    switch (status) {
      case "Pending":
        return "red";
      default:
        return "";
    }
  };

  const itemsPerPage = managementdetails?.per_page || 10;
  const totalPages = managementdetails?.total_pages || 1;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getFileUrl = (path) => {
    if (!path) return null;
    return `${process.env.REACT_APP_IMG_URL}${path}`;
  };

  const [show, setShow] = useState(false);

  const [showData, setShowData] = useState("");
  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr. No</th>
                 <th>Created Date</th>
                <th>Document Name</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Attached File</th>
                <th>Remarks</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {managementdetails?.data.length > 0 ? (
                managementdetails?.data?.map((row, index) => {
                  const fileUrl = getFileUrl(row.attach_file);

                  return (
                    <tr key={row.id}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{formatDate(row.createdAt)}</td>
                      <td>{row.name || "---"}</td>

                      <td>{formatDate(row.start_date)}</td>
                      <td>{formatDate(row.end_date)}</td>

                      <td className="file_actions">
                        <div
                          className="action_icons"
                          onClick={() => {
                            setShow(true);
                            setShowData(row);
                          }}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </div>
                      </td>

                      <td>{row.remark || "---"}</td>

                      {/* STATUS */}
                      <td
                        className={`status ${getStatusClass(
                          row?.Management_System_Requirement_Status?.name,
                        )}`}
                      >
                        {row?.Management_System_Requirement_Status?.name ||
                          "---"}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(currentPage - 1) * itemsPerPage + 1} To{" "}
            {Math.min(
              currentPage * itemsPerPage,
              managementdetails?.data?.length,
            )}{" "}
            Of {managementdetails?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>

        <Image_Show_Modal
          onHide={() => setShow(false)}
          show={show}
          showData={showData}
          imgSrc={process.env.REACT_APP_IMG_URL + showData?.attach_file}
        />
      </div>
    </>
  );
};

export default Table;
